import { render, staticRenderFns } from "./Dashboard.component.vue?vue&type=template&id=79457cac&"
import script from "./Dashboard.component.vue?vue&type=script&lang=js&"
export * from "./Dashboard.component.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.component.vue?vue&type=style&index=0&id=79457cac&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VSkeletonLoader,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})
